import { QueryKey } from "@tanstack/react-query";

export const clubQueryKeys = {
  all: () => ["club"] as QueryKey,
  details: (clubId: number) =>
    [...clubQueryKeys.all(), "details", clubId] as QueryKey,
  getCommunicationProperties: (clubId: number) =>
    [...clubQueryKeys.all(), "getCommunicationProperties", clubId] as QueryKey,
  properties: (clubId: number) =>
    [...clubQueryKeys.all(), clubId, "properties"] as QueryKey,
  connectStatus: (clubId: number) =>
    [...clubQueryKeys.all(), clubId, "connect"] as QueryKey,
  customPaymentCategory: (clubId: number) =>
    [...clubQueryKeys.all(), clubId, "customPaymentCategory"] as QueryKey,
  cancellationReason: (clubId: number) =>
    [...clubQueryKeys.all(), clubId, "cancellationReason"] as QueryKey,
  getCancellationReasonList: (clubId: number) =>
    [...clubQueryKeys.all(), clubId, "getCancellationReasonList"] as QueryKey,
};
